module.exports = __webpack_public_path__ + "media/rollover3.69b66f6c.ogg";